var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 89"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9408 0.493429C12.9408 0.22106 12.7197 7.62939e-06 12.4474 7.62939e-06H0.993421C0.721053 7.62939e-06 0.5 0.22106 0.5 0.493429V3.94738C0.5 4.21974 0.721053 4.4408 0.993421 4.4408H12.4474C12.7197 4.4408 12.9408 4.21974 12.9408 3.94738V0.493429Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9408 8.49343C12.9408 8.22106 12.7197 8.00001 12.4474 8.00001H0.993421C0.721053 8.00001 0.5 8.22106 0.5 8.49343V11.9474C0.5 12.2197 0.721053 12.4408 0.993421 12.4408H12.4474C12.7197 12.4408 12.9408 12.2197 12.9408 11.9474V8.49343Z",
    fill: "#292929"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.eb8543ab219d3ab04bc9e9abad5330c2.svg";
export { ForwardRef as ReactComponent };